import { JanelaModal } from '../../participantes/ui/JanelaModal';
import type { AcaoDeEstacao } from '../api/operacao';

interface ConfirmacaoDeEstacaoProps {
    acao: AcaoDeEstacao;
    processando: boolean;
    aoCancelar: () => void;
    aoConfirmar: () => void;
}

const TEXTOS: Record<AcaoDeEstacao, { titulo: string; verbo: string; corpo: string }> = {
    reiniciar: {
        titulo: 'Reiniciar estação?',
        verbo: 'Reiniciar',
        corpo: 'Reiniciar recomeça a estação do grupo e descarta o progresso dela; o que já foi pontuado fica.',
    },
    finalizar: {
        titulo: 'Finalizar estação?',
        verbo: 'Finalizar',
        corpo: 'Finalizar encerra a fase para o grupo e leva os participantes para a tela Aguarde.',
    },
};

/** Os popups "Reiniciar estação?" e "Finalizar estação?" (`DP-RA-041`, `AC-RA-047`). */
export function ConfirmacaoDeEstacao({ acao, processando, aoCancelar, aoConfirmar }: ConfirmacaoDeEstacaoProps) {
    const { titulo, verbo, corpo } = TEXTOS[acao];
    return (
        <JanelaModal titulo={titulo} aoFechar={aoCancelar} bloqueada={processando}>
            <p>{corpo}</p>
            <div className="botoes-confirmacao">
                <button type="button" className="botao-secundario" onClick={aoCancelar} disabled={processando}>
                    Cancelar
                </button>
                <button type="button" className="botao-confirmar botao-inativar" onClick={aoConfirmar} disabled={processando}>
                    {processando ? 'Processando…' : verbo}
                </button>
            </div>
        </JanelaModal>
    );
}
